import React, { useEffect } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { FaXmark } from "react-icons/fa6";
import classes from "./AllGamesModal.module.css";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

const AllGamesModal = ({ games = [], modal, setModal }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { user } = useSelector((state) => state?.persisted?.userSlice || {});

  useEffect(() => {
    if (modal) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }

    return () => {
      document.body.style.overflow = "auto";
    };
  }, [modal]);

  const handleGameClick = (game) => {
    setModal(false);
    if (user && user.token && user.msisdn) {
      navigate("/game", { state: { game } });
    } else {
      navigate("/login");
    }
  };

  return (
    <AnimatePresence>
      {modal && (
        <motion.div
          className={classes.modalOverlay}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          onClick={() => setModal(false)}
        >
          <motion.div
            className={classes.modalBox}
            initial={{ opacity: 0, y: 40, scale: 0.94 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: 30, scale: 0.96 }}
            transition={{ duration: 0.3, ease: "easeOut" }}
            onClick={(e) => e.stopPropagation()}
          >
            <div className={classes.modalHeader}>
              <h3 className={classes.modalTitle}>{t("33")}</h3>

              <button
                className={classes.modalCloseBtn}
                onClick={() => setModal(false)}
              >
                <FaXmark />
              </button>
            </div>

            <div className={classes.modalBody}>
              <div className={classes.modalGamesGrid}>
                {games?.map((game, idx) => (
                  <div
                    className={classes.modalGameCard}
                    key={game?.id || idx}
                    onClick={() => handleGameClick(game)}
                    style={{ cursor: "pointer" }}
                  >
                    <img
                      src={game?.game_banner}
                      alt={game?.game_name}
                      className={classes.modalGameImage}
                    />
                    <div className={classes.modalGameName}>
                      {game?.game_name}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default AllGamesModal;